module.exports = __webpack_public_path__ + "img/about__banner__small——zh.cae24043.png";